import { assert, AssertionError } from '@atlassian/eoc-common';
import { getSafe, isEmpty } from './validators';
const getTeamIdFromContext = routerContext => {
  const teamId = getSafe(() => routerContext.match.params.teamId, null);
  assert(!isEmpty(teamId), new AssertionError('eoc-schedule', 'teamId in routerContext is not defined'));
  return teamId;
};
export { getTeamIdFromContext };